export const COMMON_REQ = 'cris/teamMember/COMMON_REQ';
export const COMMON_REQ_FAIL = 'cris/teamMember/COMMON_REQ_FAIL';

export const LOAD_TEAM_MEMBERS_SUCCESS = 'cris/teamMember/LOAD_TEAM_MEMBERS_SUCCESS';

const initialState = {
	isLoading: false,
	error: null,
	users: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case COMMON_REQ:
			return {
				...state,
				isLoading: true
			};

		case COMMON_REQ_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.error
			};

		case LOAD_TEAM_MEMBERS_SUCCESS:
			const users = action.payload.data.users.map((item) => ({
				id: item.id,
				name: item.name || '',
				email: item.email || '',
				contact_office: item.contact_office || '',
				contact_home: item.contact_home || '',
				status: item.status,
				businessUnitNames: item.workplaces.length ? item.workplaces.map(item => item.business_unit.name).join(', ') : ''
			}));

			return {
				...state,
				isLoading: false,
				users: users
			};

		default:
			return state;
	}
}